import { ReactNode } from "react";
import { View, TouchableOpacity } from "react-native";
import { Text } from "react-native-paper";
import { colors } from "../../../theme";
import { Feather } from "@expo/vector-icons";

const style = {
  info: {
    iconProps: { name: "info" as const, color: colors.blue.DEFAULT },
    containerClasses: "border-blue bg-blue-lighter/40",
  },

  warn: {
    iconProps: {
      name: "alert-triangle" as const,
      color: colors.yellow.DEFAULT,
    },
    containerClasses: "border-yellow bg-yellow-lightest",
  },

  error: {
    iconProps: { name: "alert-circle" as const, color: colors.red.DEFAULT },
    containerClasses: "border-red bg-red-lightest",
  },
};

export function Callout({
  level,
  onPress,
  children,
}: {
  level: "info" | "warn" | "error";
  onPress(): void;
  children: ReactNode;
}) {
  const { iconProps, containerClasses } = style[level];

  return (
    <TouchableOpacity
      testID="callout"
      onPress={onPress}
      activeOpacity={0.7}
      className={`rounded-lg border py-3 px-4 flex-row justify-between items-center mb-4 ${containerClasses}`}
    >
      <View className="flex-row w-1/2 items-center">
        <Feather size={24} {...iconProps} />
        <Text className="pl-2 text-small-tight text-ink-darkest">{children}</Text>
      </View>
      <Text className="text-primary">Learn More</Text>
    </TouchableOpacity>
  );
}
